module.exports = __webpack_public_path__ + "img/Mensajeiniciovalidacion.724f62a0.png";